import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Box,
    IconButton,
    Menu,
    MenuItem,
    useMediaQuery,
    useTheme
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LandscapeIcon from '@mui/icons-material/Landscape';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import PeopleIcon from '@mui/icons-material/People';
import WaterDrop from '@mui/icons-material/WaterDrop';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

import logo from '../assets/logo.jpeg';

const Header = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [anchorEl, setAnchorEl] = useState(null);
    const [adminAnchorEl, setAdminAnchorEl] = useState(null);
    const userRole = localStorage.getItem('role');
    const isAdmin = userRole && userRole.toLowerCase() === 'admin';
    const isDemo = userRole && userRole.toLowerCase() === 'demo';

    const handleUpdate = () => {
        if ('caches' in window) {
            caches.keys().then(names => names.forEach(name => caches.delete(name)));
        }
        window.location.reload();
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAdminMenuOpen = (event) => {
        setAdminAnchorEl(event.currentTarget);
    };

    const handleAdminMenuClose = () => {
        setAdminAnchorEl(null);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        navigate('/login');
    };

    const menuItems = [
        { text: 'Panel', icon: <DashboardIcon />, link: '/simulations' },
        { text: 'Resumen de Círculos', icon: <WaterDrop />, link: '/resumen-circulos' },
        { text: 'Riego', icon: <AgricultureIcon />, link: '/estado-riego' },
        ...(isDemo ? [] : [
            { text: 'Cambios Diarios', icon: <ChangeCircleIcon />, link: '/cambios-diarios' },
        ]),
    ];

    const adminItems = (isAdmin && !isDemo) ? [
        { text: 'Campos', icon: <LandscapeIcon />, link: '/campos' },
        { text: 'Usuarios', icon: <PeopleIcon />, link: '/admin/users' },
    ] : [];

    return (
        <AppBar position="static">
        <Toolbar>
            <Box 
                    component={Link} 
                    to="/" 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        flexGrow: 1,
                        textDecoration: 'none' 
                    }}
                >
            <img src={logo} alt="Logo" style={{ height: 40, marginRight: 10 }} />
            <Typography variant="h6" component="div" sx={{ fontFamily: 'Poppins, Arial, sans-serif', color: 'white' }}>
                Qarpana
            </Typography>
            </Box>
            
            {isMobile ? (
            <>
                <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleMenu}
                >
                <MenuIcon />
                </IconButton>
                <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                >
                {menuItems.map((item) => (
                    <MenuItem key={item.text} onClick={() => { handleClose(); navigate(item.link); }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {item.icon}
                        <Typography sx={{ ml: 1, fontFamily: 'Poppins, Arial, sans-serif' }}>{item.text}</Typography>
                    </Box>
                    </MenuItem>
                ))}
                {adminItems.map((item) => (
                    <MenuItem key={item.text} onClick={() => { handleClose(); navigate(item.link); }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {item.icon}
                        <Typography sx={{ ml: 1, fontFamily: 'Poppins, Arial, sans-serif' }}>{item.text}</Typography>
                    </Box>
                    </MenuItem>
                ))}
                <MenuItem onClick={handleUpdate}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <SystemUpdateAltIcon />
                    <Typography sx={{ ml: 1, fontFamily: 'Poppins, Arial, sans-serif' }}>Actualizar app</Typography>
                    </Box>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <LogoutIcon />
                    <Typography sx={{ ml: 1, fontFamily: 'Poppins, Arial, sans-serif' }}>Cerrar Sesión</Typography>
                    </Box>
                </MenuItem>
                </Menu>
            </>
            ) : (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {menuItems.map((item) => (
                <Button 
                    key={item.text}
                    color="inherit" 
                    component={Link} 
                    to={item.link}
                    startIcon={item.icon}
                    sx={{ mr: 1, fontFamily: 'Poppins, Arial, sans-serif' }}
                >
                    {item.text}
                </Button>
                ))}
                {adminItems.length > 0 && (
                    <>
                        <Button 
                            color="inherit" 
                            onClick={handleAdminMenuOpen} 
                            startIcon={<SettingsIcon />}
                            endIcon={<ArrowDropDownIcon />}
                            sx={{ mr: 1, fontFamily: 'Poppins, Arial, sans-serif' }}
                        >
                            Administración
                        </Button>
                        <Menu
                            anchorEl={adminAnchorEl}
                            open={Boolean(adminAnchorEl)}
                            onClose={handleAdminMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            {adminItems.map((item) => (
                                <MenuItem key={item.text} onClick={() => { handleAdminMenuClose(); navigate(item.link); }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {item.icon}
                                        <Typography sx={{ ml: 1, fontFamily: 'Poppins, Arial, sans-serif' }}>{item.text}</Typography>
                                    </Box>
                                </MenuItem>
                            ))}
                        </Menu>
                    </>
                )}
                <Button
                color="inherit"
                onClick={handleUpdate}
                startIcon={<SystemUpdateAltIcon />}
                sx={{ mr: 1, fontFamily: 'Poppins, Arial, sans-serif', opacity: 0.7, '&:hover': { opacity: 1 } }}
                title="Actualizar la aplicación"
                >
                Actualizar
                </Button>
                <Button
                color="inherit"
                onClick={handleLogout}
                startIcon={<LogoutIcon />}
                sx={{ fontFamily: 'Poppins, Arial, sans-serif' }}
                >
                Cerrar Sesión
                </Button>
            </Box>
            )}
        </Toolbar>
        </AppBar>
    );
};

export default Header;